import { render, staticRenderFns } from "./delete-element-icon.vue?vue&type=template&id=02e71fc0"
import script from "./delete-element-icon.vue?vue&type=script&lang=ts"
export * from "./delete-element-icon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports